import styled from 'styled-components'

export const Button = styled.button`
  height: 36px;
  color: var(--button-color);
  border-color: var(--button-color);
  &:focus {
    outline: var(--button-color);
  }
`
